<template>
  <fieldset class="radio-group"
            :id="`${id}RadioButtonGroup`"
            :aria-labelledby="`${id}RadioGroupLabel`"
            role="radiogroup">
    <legend :id="`${id}RadioGroupLabel`"
            class="sr-only">
      {{ ariaLabel }}
    </legend>
    <b-form-radio-group v-model="modelValue"
                        ref="removableRole">
      <slot></slot>
    </b-form-radio-group>
  </fieldset>
</template>

<script>
import Logger from '../../../utility/loggerUtil'

export default {
  name: 'radio-group',

  props: {
    ariaLabel: {
      type: [String],
      required: true
    },

    id: {
      type: [String],
      default: ''
    },

    value: {
      type: [String, Boolean, Number],
      default: ''
    }
  },

  mounted () {
    try {
      this.$refs.removableRole.$el.removeAttribute('role')
    } catch (e) {
      Logger.debug(`Error removing attribute: ${e}`)
    }
  },

  computed: {
    modelValue: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>
